import { render } from "./FormSellos.vue?vue&type=template&id=5d8502e2&scoped=true"
import script from "./FormSellos.vue?vue&type=script&lang=js"
export * from "./FormSellos.vue?vue&type=script&lang=js"

import "./FormSellos.vue?vue&type=style&index=0&id=5d8502e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d8502e2"

export default script